export default "__VITE_ASSET__TqUBYmU1__"